import { observable, computed } from 'mobx'
import { persist } from 'mobx-persist'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

//stores
import { AdventureStore, Category } from 'modules/adventure/AdventureStore'
import { RequestsStore } from 'modules/reservations/RequestsStore'

//models
import Package from 'models/Package'

momentDurationFormatSetup(moment)

class Adventure {

  @persist @observable title;
  @observable fk_type;
  @observable image;
  @observable images;
  @observable banner;
  @observable min;
  @observable max;
  @observable frequentlyQuestion;
  @observable block_request_hours_before;
  @observable block_participation_hours_before;
  @observable check_before_request;
  @observable only_public;
  @observable description;
  @observable long_description;
  @observable urn;
  @observable url;
  @observable voucher_expiration_days;
  @observable voucher_enabled;
  @observable online_scheduling;
  @observable cancel_rules;
  @persist('list') @observable packages = [];
  @observable credit_card_enabled;
  @observable boleto_enabled;
  @observable local_payment_enabled;

  // Locale
  @observable cep;
  @observable state;
  @observable city;
  @observable street;
  @observable neighborhood;
  @observable number;
  @observable formatedAddress;

  // Meeting point
  @observable sameLocaleAndMeetingPoint;
  @observable meetingPointCep;
  @observable meetingPointComplement;
  @observable meetingPointLat;
  @observable meetingPointLng;
  @observable meetingPointStreet;
  @observable meetingPointNumber;
  @observable meetingPointCity;
  @observable meetingPointState;
  @observable meetingPointFormatedAddress;

  // Additional Informations
  @observable whatToKnow;
  @observable aboutTheOperator;
  @observable important;
  @observable script;
  @observable whyLiveThisExperience;
  @observable whatDoesNotInclude;
  @observable requirements;
  @observable whatToTake;
  @observable whatsNearby;
  @observable whatToWear;
  @observable otherRules;
  @observable scheduleRules = [];
  @observable paymentMethods = {
    credit_card: false,
    boleto: false,
    local: false
  };
  @observable requestCustomFields = []
  @observable reserveCustomFields = []
  @observable fill_all_reserves = false

  // Terms
  @observable terms;

  constructor(json = {}) {
    //app used
    this.pk_adventure = json.pk_adventure || null;
    this.title = json.title || ''; // OBRIGATORIO
    this.image = json.image || ''; // OBRIGATORIO
    this.images = json.images || []; // OBRIGATORIO
    this.banner = json.banner || ''; // OBRIGATORIO
    this.fk_type = json.fk_type || ''; // OBRIGATORIO
    this.duration = json.duration || ''; // OBRIGATORIO
    this.long_description = json.long_description || ''; // OBRIGATORIO
    this.min = json.min || ''; // OBRIGATORIO
    this.max = json.max || ''; // OBRIGATORIO
    this.block_participation_hours_before = json.block_participation_hours_before;
    this.block_request_hours_before = json.block_request_hours_before;
    this.check_before_request = json.check_before_request || false;

    this.video = json.video || '';
    this.adrenalevel = json.adrenalevel || 0;
    this.average_rate = json.average_rate || 0;
    this.description = json.description || '';
    this.price = json.price || 0;

    this.status = json.status || '';
    this.long_description = json.long_description || '';
    this.online_scheduling = json.online_scheduling || '';
    this.neighborhood = json.neighborhood || '';
    this.only_public = json.only_public || '';
    this.url_name = json.url_name || '';
    this.url = json.url || '';
    this.type_name = json.type_name || '';
    this.fk_company = json.fk_company || '';
    this.fk_category = json.fk_category || '';
    this.category = new Category(json.category) || {};

    this.packages = json.packages ? json.packages.map((p) => new Package(p)) : []; // OBRIGATORIO
    this.operatings = json.operatings || [];
    this.scheduleRules = json.scheduleRules || [];
    this.credit_card_enabled = json.credit_card_enabled || false;
    this.boleto_enabled = json.boleto_enabled || false;
    this.local_payment_enabled = json.local_payment_enabled || false;
    this.paymentMethods = {
      credit_card: this.credit_card_enabled,
      boleto: this.boleto_enabled,
      local: this.local_payment_enabled
    }
    // Additional Informations
    this.aboutTheOperator = json.about_the_operator || '';
    this.whyLiveThisExperience = json.why_live_this_experience || '';
    this.otherRules = json.other_rules || '';
    this.whatsNearby = json.whats_nearby || '';

    this.whatToKnow = json.whatToKnow || [];
    this.requirements = json.requirements || [];
    this.important = json.important || [];
    this.whatDoesNotInclude = json.whatDoesNotInclude || [];
    this.whatToTake = json.whatToTake || [];
    this.whatToWear = json.whatToWear || [];
    this.script = json.script || [];
    this.frequentlyQuestion = json.frequentlyQuestion || [];


    // Locales and MeetingPoint 

    // OBRIGATORIO
    // Locale
    this.cep = json.cep || '';
    this.complement = json.complement || '';
    this.lat = Number(json.lat) || null;
    this.lng = Number(json.lng) || null;
    this.street = json.street || '';
    this.number = json.number || '';
    this.city = json.city || '';
    this.state = json.state || '';
    this.neighborhood = json.neighborhood || '';
    this.formatedAddress = json.formatedAddress || '';

    if (!this.formatedAddress) {
      let formatedAddress = ''
      if (!!json.street && !!json.number) {
        formatedAddress += `${json.street}, ${json.number} - `;
      }
      if (!!json.neighborhood) {
        formatedAddress += `${json.neighborhood}, `;
      }
      if (!!json.city && !!json.state) {
        formatedAddress += `${json.city} - ${json.state}`;
      }
      if (!!json.cep) {
        formatedAddress += `, ${json.cep}`;
      }
      this.formatedAddress = formatedAddress;
    }

    // OBRIGATORIO
    // Meeting Point
    this.sameLocaleAndMeetingPoint = json.same_locale_and_meeting_point || 1;
    this.meetingPointCep = json.meeting_point_cep || '';
    this.meetingPointComplement = json.meeting_point_complement || '';
    this.meetingPointLat = Number(json.meeting_point_lat) || null;
    this.meetingPointLng = Number(json.meeting_point_lng) || null;
    this.meetingPointStreet = json.meeting_point_street || '';
    this.meetingPointNumber = json.meeting_point_number || '';
    this.meetingPointCity = json.meeting_point_city || '';
    this.meetingPointState = json.meeting_point_state || '';
    this.meetingPointFormatedAddress = json.meeting_point_formated_address || '';
    this.meetingPointNeighborhood = json.meeting_point_neighborhood || '';
    this.meetingPointFormatedAddress = json.meetingPointFormatedAddress || '';

    if (!this.meetingPointFormatedAddress) {
      let meetingPointFormatedAddress = ''
      if (!!json.meeting_point_street && !!json.meeting_point_number) {
        meetingPointFormatedAddress += `${json.meeting_point_street}, ${json.meeting_point_number} - `;
      }
      if (!!json.meeting_point_neighborhood) {
        meetingPointFormatedAddress += `${json.meeting_point_neighborhood}, `;
      }
      if (!!json.meeting_point_city && !!json.meeting_point_state) {
        meetingPointFormatedAddress += `${json.meeting_point_city} - ${json.meeting_point_state}`;
      }
      if (!!json.meeting_point_cep) {
        meetingPointFormatedAddress += `, ${json.meeting_point_cep}`;
      }
      this.meetingPointFormatedAddress = meetingPointFormatedAddress;
    }

    this.google_calendar_id = json.google_calendar_id || null

    this.is_deleted = json.is_deleted || 0;

    this.vouchers = json.vouchers || []
    this.voucher_enabled = json.voucher_enabled || false
    this.voucher_expiration_days = json.voucher_expiration_days || undefined
    this.cancel_rules = json.cancel_rules || ''
    this.fill_all_reserves = json.fill_all_reserves || false

    this.urn = json.urn || ''


    // terms
    this.terms = json.terms || ''
  }

  @computed
  get isDisabled() {
    return this.status === 3
  }

  @computed
  get isWaiting() {
    return this.status === 2
  }
  @computed
  get isPublished() {
    return this.status === 1
  }

  @computed
  get isDraft() {
    return !this.status
  }

  @computed
  get hasRequests() {
    return !!(RequestsStore.requests.filter(request => (
      request.fk_adventure === this.pk_adventure
    )).length)
  }

  @computed
  get formatDurationToNumber() {
    return this.duration
      .split(' ')
      .reduce((acumm, unit) => {
        //unit: number (e.g. h: 12) => key:horas / value:12
        acumm[unit.replace(/[0-9]/g, '')] = parseInt(unit, 10) || ''
        return acumm
      }, {});
  }

  @computed
  get adventureDataStepsCompleted() {
    return [
      !!this.fk_type,
      !!this.title,
      !!this.long_description || !!this.description || !!this.duration,
      !this.imagesCompleted,
      Number(this.max) > Number(this.min) || !!Number(this.max),
      Number(this.max) > Number(this.min) || !!Number(this.max),
      !!(this.formatedAddress || this.street)
    ]
  }

  @computed
  get isReadyToPublish() {
    return !!this.fk_category && // Categoria / Atividade
      !!this.title && // Nome
      !!this.long_description && // Sobre
      !!this.description && // Resumo
      !!this.duration && // Duração
      !this.imagesCompleted && // Banner / Galeria / Thubmnail
      (Number(this.max) >= Number(this.min) && !!this.max && !!this.min) && // Maximo / Minimo participantes
      this.localeFilled && // Local da aventura
      this.meetingPointFilled && // Local de encontro
      this.packageDataIsCompleted // Pacotes
  }

  @computed
  get adventureDataCompletedLength() {
    return this.adventureDataStepsCompleted.filter(Boolean).length
  }

  @computed
  get adventureDataIsCompleted() {
    return this.adventureDataCompletedLength === 7
  }

  @computed
  get packageDataIsCompleted() {
    return !!this.packages.length
  }

  @computed
  get scheduleDataIsCompleted() {
    return !!this.operatings.length
  }

  @computed
  get imagesCompleted() {
    return !(this.images.length > 0 && this.image !== "" && this.banner !== "");
  };

  @computed
  get cepFilled() {
    return (this.cep.length === 9);
  }

  @computed
  get localeFilled() {
    return (this.lat !== "" && this.lng !== "");
  }

  @computed
  get meetingPointCepFilled() {
    return (this.meetingPointCep.length === 9);
  }

  @computed
  get meetingPointFilled() {
    return (this.meetingPointLat !== "" && this.meetingPointLng !== "");
  }

  @computed
  get isInSeenedPublisheds() {
    return !!AdventureStore.seenedAdventuresPublisheds.find((a) => this.pk_adventure === a.pk_adventure);
  }

  @computed
  get durationFormatted() {
    const durationArr = this.duration.split(":")

    return moment.duration({
      hours: parseFloat(durationArr[0], 10),
      minutes: parseFloat(durationArr[1], 10)
    }).format("d[d] h[h] m[m] s[s]", { trim: "both" })
  }


}

export default Adventure


// WEBPACK FOOTER //
// ./src/models/Adventure.js